import { RequestType } from '../request/enum/RequestType';
import RequestStatus from '../request/enum/RequestStatus';
import { OfferStatus } from '../../page/RequestsCreatePage/type/enums/OfferStatus';

export interface UserResponseDTO {
    id: number;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    mail?: string;
    role: string;
}

export interface RequestViewSettingsDTO {
    title?: string;
    description?: string;
}

export interface MessageImageDTO {
    id: string;
    requestId: string;
    messageId: string;
    imageUrl: string;
    imageThumbUrl: string;
    text?: string;
}

export interface OfferPositionResponseDTO {
    id: string;
    offerId: string;
    productName: string;
    brand?: string;
    description?: string;
    price: number;
    quantity: number;
    deliveryTime?: string;
    notes?: string;
    productCode?: string;
    supplier?: string;
    images: OfferImageResponseDTO[];
}

export interface OfferImageResponseDTO {
    id: string;
    uniqueId: string;
    image: string;
    imageThumb: string;
    groupId: string;
}

export interface OfferResponseDTO {
    id: string;
    messageId: string;
    requestId: string;
    status: OfferStatus;
    createdAt: string;
    modifiedAt: string;
    offerPositions: OfferPositionResponseDTO[];
}

export enum MessageType {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    OFFER = 'OFFER',
    SYSTEM = 'SYSTEM',
}

export interface MessageResponseDTO {
    id: string;
    requestId: string;
    to: number;
    from: number;
    text?: string;
    images?: MessageImageDTO[];
    offer?: OfferResponseDTO;
    createdAt: string;
    messageType: MessageType;
}

export interface MessagePageDTO {
    content: MessageResponseDTO[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    first: boolean;
    last: boolean;
}

export interface RequestResponseDTO {
    id: string;
    type: RequestType;
    client: UserResponseDTO;
    operator: UserResponseDTO;
    clientView?: RequestViewSettingsDTO;
    operatorView?: RequestViewSettingsDTO;
    status: RequestStatus;
    messages: MessagePageDTO;
    createdAt: string;
    modifiedAt: string;
}

